import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconJudgeGavel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconJudgeGavel"><Path d="M16.5 2.18945L8.68934 10.0001L12.5 13.8108L15.875 10.4358L20.75 15.3108L21.8107 14.2501L16.9357 9.37511L20.3107 6.00011L16.5 2.18945Z" fill="currentColor"/><Path d="M3.35 7.20011L2.45 8.40011L5.65 10.8001L6.55 9.60011L3.35 7.20011Z" fill="currentColor"/><Path d="M1 12.5001V14.0001H5V12.5001H1Z" fill="currentColor"/><Path d="M4.20943 16.5001L3.20943 19.5001H2V21.0001H17V19.5001H15.7906L14.7906 16.5001H4.20943Z" fill="currentColor"/></CentralIconBase>;
});

export default IconJudgeGavel;
